<template>
  <div id="app">
    <div class="container">
      <div class="row mb-2" style="margin-top: 30px;">
        <span class="col" style="text-align: center; font-size: 40px; color: #2c3e50;">
          Data Creation
        </span>
      </div>
      <hr class="mx-auto" style="border: 2px double #6385ce; max-width: 1073px;">

      <nav>
        <div class="nav nav-pills nav-fill" id="nav-tab" role="tablist">
          <a class="nav-item nav-link"
             v-on:click="switch_tab('overview')"
             v-bind:class="{
              'active': show_tab_overview
             }"
          ><span style="font-size: 25px">Overview</span></a>
          <a class="nav-item nav-link"
             v-on:click="switch_tab('step-by-step')"
             v-bind:class="{
              'active': show_tab_step_by_step
             }"
          ><span style="font-size: 25px">Creation Method</span></a>

          <a class="nav-item nav-link"
             v-on:click="switch_tab('pay-plan')"
             v-bind:class="{
              'active': show_tab_pay_plan
             }"
          ><span style="font-size: 25px">Payment</span></a>

          <a class="nav-item nav-link"
             v-on:click="switch_tab('real-creation')"
             v-bind:class="{
              'active': show_tab_real_creation
             }"
          ><span style="font-size: 25px">Workspace</span></a>
        </div>
      </nav>

      <div class="container" v-if="show_tab_overview">
        <div class="card-body" style="text-align: left; margin-top: 5px;">
          Congratulations to all of you who have finished the Qualification and successfully passed the Qualification Test. Now, let's get started with the <strong>Data Creation</strong>.
          You have already learned the basic knowledge required for data creation at the Qualification task. If you face any questions or difficulties during Data Creation, please feel free to revisit the <B><a href="https://qual-before-creation.click" target="_blank">Qualification</a></B> section.
        </div>
        <Overview></Overview>
        <div class="card-text" style="text-align: left">
          Let's walk through the details step by step in the Creation Method.
          <br/><br/>
        </div>
        <hr class="mx-auto" style="border: 2px double #6385ce; max-width: 1073px;">
        <button
                  type="button"
                  class="btn btn-info btn-lg"
                  style="float: right; background-color: steelblue; color: white;"
                  onclick="window.scrollTo(0,0)"
                  v-on:click="switch_tab('step-by-step');"
          >How to create data
        </button>
      </div>

      <div class="container" v-if="show_tab_step_by_step" style=" text-align: left">
        <div class="card-body" style="text-align: left">
          Please pay attention to the following points while reading this page.<br/>
          <div style="margin-left: 20px; margin-top: 5px; line-height: 180%">
            1) What are the meanings for Question, Correct, and Incorrect? <br/>
            2) What are the criteria needed to be met when creating data? <br/>
            3) What kind of data would like to create in the end? <br/>
            4) How Correct and Incorrect are being used in the QA Data?
          </div>
        </div>

        <StepByStep></StepByStep>
        <br/>
        <Creation_examples></Creation_examples>
        <br/>
        <hr class="mx-auto" style="border: 2px double #6385ce; max-width: 1073px;">
        <div class="row">
            <div class="col-8"></div>
            <div class="col-4">
              <button
                        type="button"
                        class="btn btn-info btn-lg v-btn--right"
                        style="float: right; background-color: steelblue; color: white"
                        onclick="window.scrollTo(0,0)"
                        v-on:click="switch_tab('pay-plan');"
                >Spam policy & Payment
              </button>
            </div>
        </div>
      </div>

      <div class="container" v-if="show_tab_pay_plan">
        <div>
          <br/><br/>
          <Payment></Payment>
          <br/>
          <div class="row">
            <div class="col-8"></div>
            <div class="col-4">
              <button
                        type="button"
                        class="btn btn-info btn-lg v-btn--right"
                        style="float: right; background-color: steelblue; color: white"
                        onclick="window.scrollTo(0,0)"
                        v-on:click="switch_tab('real-creation');"
                >Start Data Creation
              </button>
            </div>
          </div>
        </div>
      </div>


      <div class="container" v-if="show_tab_real_creation && submitted" style="margin-top: 5px;">
        <div class="card-body alert-success" style="font-size: 20px; text-align: left; margin-top: 40px;">
          <strong>
            This is the end of this HIT. Your answers are successfully confirmed.<br/>
            If you want to participate more in this HIT, after submit with below <strong>[Submit]</strong> button and re-enter this HIT. <br/>
            You can participate in maximum 8 times.<br/>
            Otherwise, just click the below button and leave here.<br/><br/>

            Thank you for your time :))
          </strong>
        </div>
        <br/><br/>
        <button
                type="button"
                class="btn btn-primary btn-lg"
                v-on:click="submitToTurk()"
                style="color: white; padding: 20px; background-color: lightseagreen; border: none; float: right"
                data-balloon-pos="up"
        ><strong>Submit</strong>
        </button>
      </div>


      <div class="container" v-if="show_tab_real_creation && !submitted" style="margin-top: 5px;">
        <div class="card-body" style="text-align: left;">
          This page is for the actual Data Creation work.<br/>
          You can create new data in the workspace by referring to the criteria and reference sites specified below.
        </div>
        <div class="card">
          <span class="card-header"
             aria-expanded="true"
             style="color: rgb(255,0,0); background-color: rgba(255,213,176,0.58); text-align: left">
            <span style="font-size: 22px"><strong><strong>*** CRITERIA ***</strong></strong></span>
            <span style="font-size: 18px; margin-left: 20px;">(must be observed)</span>
          </span>

          <div>
            <v-card-text style="margin-left: 10px; font-size: 16px; line-height: 160%; text-align: left;">
              <div style="margin-left: 10px"><strong>
                <div style="font-size: 16px; text-indent: -20px; margin-left:20px;">1) Specific wordings to the question which could become hints for distinguishing between candidates,
                  should be mentioned only in one of the following situations :&nbsp;&nbsp;&nbsp;&nbsp;
                  (1) Both Correct AND Incorrect &nbsp;&nbsp;
                  (2) Neither Correct NOR Incorrect.
                </div>
                <table id="table-in-condition" style="margin-top: 10px; margin-left: 20px; margin-bottom:10px;">
                  <tbody>
                    <tr style="background-color: white; border-bottom: 2px solid darkgrey;">
                      <td style="width: 100px; text-align: center;">Question</td>
                      <td style="width: 350px; padding-left: 10px;">To open a <strong style="color: tomato">letter</strong>, </td>
                    </tr>

                    <tr style="background-color: white">
                      <td style="text-align: center;">Correct</td>
                      <td style="padding-left: 10px;">use a (<del><strong style="color: tomato">letter</strong></del>) <strong style="color: tomato">utility</strong> knife to open an edge.</td>
                    </tr>

                    <tr style="background-color: white">
                      <td style="text-align: center;">Incorrect</td>
                      <td style="padding-left: 10px;">use a foil cutter to open an edge.</td>
                    </tr>
                  </tbody>
                </table>
                <span style="font-size: 16px; margin-left: 20px;">To satisfy this condition, using synonyms or pronouns may help you to create the data more easily.</span>
                <br/><br/>

                <span style="font-size: 16px">
                  2) Incorrect should be sentence with specific <U>plausible content</U>, not outrageous weirdness.
                </span><br/>
                </strong>
                <span>
                  <span style="margin-left: 30px; margin-top: 15px; float: left">
                    can be used to <span style="color: tomato"> remove rust from metal</span>
                  </span>
                  <i class="material-icons"
                     style="background-color:white;
                            color: black;
                            font-size: 32px;
                            float: left;
                            margin-top:12px; margin-left: 15px; margin-right:15px;"
                  >trending_flat</i>
                  <span style="margin-top: 15px; float: left">
                    can be used to remove rust <span style="color: royalblue"> stains </span> from <span style="color: royalblue"> bath tub</span>. &nbsp;&nbsp; (O)
                  </span>
                  <br/><br/>
                  <i class="material-icons"
                     style="background-color:white;
                            color: black;
                            font-size: 32px;
                            float: left;
                            margin-left: 330px; margin-right:15px;"
                  >trending_flat</i>
                  <span style="margin-top: 5px; float:left">
                    can be used to <span style="color: royalblue;">make a cake from metal.</span> &nbsp;&nbsp; (X)
                  </span>
                </span>
                <br/><br/>

                <span style="font-size: 16px"><strong>
                  3) To maximize the similarity, wordings for the 'Incorrect' should be modified <U>as little as possible</U> from the 'Correct'.
                </strong></span>
                <br/>
                <span>
                  <span style="margin-left: 30px; margin-top: 15px; float: left">
                    can be used to remove rust from <span style="color: tomato">metal</span>
                  </span>
                  <i class="material-icons"
                     style="background-color:white;
                            color: black;
                            font-size: 32px;
                            float: left;
                            margin-top:12px; margin-left: 15px; margin-right:15px;"
                  >trending_flat</i>
                  <span style="margin-top: 15px; float: left">
                    can be used to remove rust <span style="color: royalblue">stains</span> from <span style="color: royalblue">bath tub</span>. &nbsp;&nbsp; (O)
                  </span>
                  <br/><br/>
                  <i class="material-icons"
                     style="background-color:white;
                            color: black;
                            font-size: 32px;
                            float: left;
                            margin-left: 330px; margin-right:15px;"
                  >trending_flat</i>
                  <span style="margin-top: 5px; margin-bottom:15px; float:left">
                    <span style="color: royalblue">is a good cleaner</span>. &nbsp;&nbsp; (X)
                  </span>
                </span>
              </div>
            </v-card-text>
          </div>
        </div>

        <div class="alert-warning" style="padding: 20px; margin-top: 20px; text-align: left; line-height: 170%; font-size: 16px; color: mediumvioletred; background-color: #fffccb">
          <div style="font-size: 22px; margin-bottom: 10px;"><strong>🚨 &nbsp;Notice &nbsp;🚨</strong></div>
          <li style="text-indent: -20px; margin-left: 20px;">
            <strong>If the contents of the provided data are strange or do not make sense to you, you can amend them directly.</strong> <br/>
            (However, the amendment to the questions and corrects must be with physical commonsense.)
          </li>
          <br/>
          <li style="text-indent: -20px; margin-left: 20px;">
            If you find that the data is difficult to construct,
            <strong>you could move onto next data by clicking the 'pass' button</strong> located at the top right corner of the corresponding data with explanation given. <br/>
            (Please note that you cannot receive compensation for problems that have been skipped.)
          </li>
          <br/>
          <li style="text-indent: -20px; margin-left: 20px;">
            <strong>When you refresh this page, the previous data is lost, so be careful not to press it!</strong>
          </li>
        </div>
        <br/>

        <div class="card" id="reference_site">
          <span class="card-header"
             aria-expanded="true"
             style="color: rgba(0,0,205,0.66); background-color: rgba(97,148,189,0.32); text-align: left">
            <span style="font-size: 20px"><strong>REFERENCE SITES </strong></span>
          </span>
          <div id="collapseEvent2" class="collapse show">
            <v-card-text style="margin-left: 10px; font-size: 16px; text-align: left">
              <div style="margin-left:10px; line-height: 160%; font-size: 16px">
                If you are lacking of ideas, you could refer to the sites below.<br/>
                However, please just treat them as a references for coming up with your own solution.<br/>
              </div>
              <br/>
              <div style="margin-left: 10px">
                1) <a href="https://www.instructables.com/howto/" target="_blank">https://www.instructables.com/ </a><br/><br/>
                2) <a href="https://www.wikihow.com/" target="_blank">https://www.wikihow.com/ </a><br/><br/>
              </div>
            </v-card-text>
          </div>
        </div>
        <br/>
        <br id="workspace_title">
        <br/><br/>

        <div>
          <button class="btn btn-5"
                  v-on:click="pre_question"
                  aria-label="You can move back and forth without losing your annotations. However, do not refresh this page using the refresh button of your browser."
                  data-balloon-pos="up"
                  data-balloon-length="large"
                  style="float:left;"
          >
            <div style="font-size: 18px; font-family: Helvetica Neue,serif; margin-bottom:7px;">PREVIOUS</div>
            <div style="color: black; font-size: 36px;" class="material-icons">arrow_back_ios</div>
          </button>

          <button class="btn btn-5"
                  v-on:click="next_question"
                  aria-label="You can move back and forth without losing your annotations. However, do not refresh this page using the refresh button of your browser."
                  data-balloon-pos="up"
                  data-balloon-length="large"
                  style="float:right; margin-bottom: 20px; margin-left: 40px;"
          ><div style="font-size: 18px; font-family: Helvetica Neue,serif; margin-bottom:7px;">NEXT</div>
            <span style="color: black; font-size: 36px;" class="material-icons">arrow_forward_ios</span>
          </button>
          <br/>

          <h1 style="text-align: center;"> WORK SPACE </h1>
          <hr class="mx-auto" style="border: 1px solid white; max-width: 1000px;">
          <question
              v-for="(item, key) in creation_seeds[this.stage]"
              v-bind:key="key"
              v-bind:index="key.toString()"
              v-bind:annotation="item"
          >
          </question>
          <button class="btn btn-5"
                  v-on:click="pre_question"
                  aria-label="You can move back and forth without losing your annotations. However, do not refresh this page using the refresh button of your browser."
                  data-balloon-pos="up"
                  data-balloon-length="large"
                  style="float:left;"
          >
            <div style="font-size: 18px; font-family: Helvetica Neue,serif; margin-bottom:7px;">PREVIOUS</div>
            <div style="color: black; font-size: 36px;" class="material-icons">arrow_back_ios</div>
          </button>

          <button class="btn btn-5"
                  v-on:click="next_question"
                  aria-label="You can move back and forth without losing your annotations. However, do not refresh this page using the refresh button of your browser."
                  data-balloon-pos="up"
                  data-balloon-length="large"
                  style="float:right; margin-bottom: 20px; margin-left: 40px;"
          ><div style="font-size: 18px; font-family: Helvetica Neue,serif; margin-bottom:7px;">NEXT</div>
            <span style="color: black; font-size: 36px;" class="material-icons">arrow_forward_ios</span>
          </button>
          <br/><br/><br/><br/><br/>
        </div>

        <div v-if="(no_more_add && all_answered && (!loading || submitting))"
             style="font-size: 18px; text-align: left; padding: 20px;"
             class="alert alert-warning"
             role="alert">
          <strong>
             "You have already used all the chances to load new data.
            Please click the blue button [Submit the Data] below to submit all of your data. Additional bonuses will be paid out within 2 weeks.
            Thank you!
          </strong>
        </div>

        <ul class="list-group list-group-flush" style="float: left"><strong>
          <li class="list-group-item mx-auto"
              style="text-align: left;"
              v-bind:class="{
                'list-group-item-danger': this.not_yet !== 0,
                'list-group-item-success': this.not_yet === 0,
            }"
          >
            <span style="margin-right: 5px; font-size: 16px;">Not answered yet</span>
            :
            <span style="margin-left: 15px; margin-right: 10px; font-size: 18px;"> {{this.not_yet}} </span>data
          </li>
          <li class="list-group-item mx-auto"
              style="text-align: left;"
              v-bind:class="{
                'list-group-item-warning': !all_answered,
                'list-group-item-success': all_answered,
            }"
          >
            <strong style="margin-right: 5px; font-size: 16px;">Expected Pay </strong><br/>
            <span style="margin-right: 20px; font-size: 16px;">ㄴ Qualification Pass Reward </span>
            <span style="margin-right: 20px; font-size: 18px;"><strong>:</strong></span>
<!--            <i class="material-icons" style="font-size: 16px; margin-right:20px; vertical-align: -3px;"><strong>trending_flat</strong></i>-->
            <span style="font-size: 18px;"> $ 1</span><br/>
            <span style="margin-right: 20px; font-size: 16px;">ㄴ Creation ( {{this.prev_add + this.add_count}} answered * $ 0.7 ) </span>
            <span style="margin-right: 20px; font-size: 18px;"><strong>:</strong></span>
<!--            <i class="material-icons" style="font-size: 16px; margin-right:20px; vertical-align: -3px;"><strong>trending_flat</strong></i>-->
            <span style="font-size: 18px;"> $ {{this.total_payment.toFixed(2)}}</span>
          </li>
        </strong>
        </ul>

        <button class="btn btn-5"
                v-on:click="load_additional"
                aria-label="The more data you create, the more reward you can get. But, be aware that once you receive new data, you can no longer fix previous data. And the load new data will take about 10~30 seconds."
                data-balloon-pos="down"
                data-balloon-length="large"
                :disabled="!all_answered || this.loading || this.no_more_add"
                style="float:right; font-size: 20px; background-color: mediumvioletred; color: white"
        ><strong>Get {{this.number_of_additions}} more data ({{this.max_add_times - this.add_times}} chances left)</strong>
        </button>


        <div v-if="this.loading && !this.submitting" class="loader" style="float: right; margin-right: 20px;margin-top: -10px;"/>
        <div v-if="this.loading && !this.submitting" style="float: right; margin-right: 10px; font-size: 16px;"><strong>Uploading... Please wait. <br/>(about10~30 seconds)</strong></div>

        <br/><br/><br/><br/><br/><br/><br/><br/>

        <div style="text-align: left; margin-bottom: 5px;">
          <strong>Optional Feedback</strong>
        </div>
        <v-textarea
            v-model="feedback"
            placeholder="If you have any questions or feedback, please feel free to let us know."
            outlined
            rows="3"/>

        <div v-if="!this.all_answered" class="alert alert-danger" role="alert">
          <strong>"Data {{(this.not_answered.toString())}}" has not yet been fully answered. <br/>
            Please fill out all responses (Incorrect, New Question, and 4 Check boxes).</strong><br/>
        </div>

        <div v-if="this.all_answered"
             class="alert alert-success"
             role="alert">
            <strong>You have successfully answered all questions. <br/>
              If you want to generate more data and get more bonus, click violet red <strong>[Get more data]</strong> button above.<br/>
              Otherwise, if there is nothing more to check, please submit it by hit the blue <strong>[Confirm the data]</strong> button below.<br/>
            </strong>
        </div>


        <button
                type="button"
                class="btn btn-primary btn-lg"
                v-on:click="submitToUs()"
                :disabled="!this.all_answered || this.loading"
                style="color: white; padding: 20px; float: left; margin-left: 450px;"
                data-balloon-pos="up"
                aria-label="Please double-check that there are no blanks and unanswered questions."
        ><strong>Confirm the data</strong>
        </button>
        <div v-if="this.loading && this.submitting" class="loader" style="float: left; margin-left: 30px;margin-top: 5px;"/>
        <div v-if="this.loading && this.submitting" style="float: left; margin-left: 10px; margin-top: 12px; font-size: 16px;"><strong>Uploading... Please wait. <br/>(about10~30 seconds)</strong></div>

        <br/><br/><br/><br/>
      </div>

      <div>
        <form
            name='mturk_form'
            method='post'
            id='mturk-external-submit-form'
            v-bind:action="mturk_params.turkSubmitTo"
            type='hidden'
        >
          <input type='hidden' name='assignmentId' id='assignmentId' v-bind:value="mturk_params.assignmentId"/>
          <input type='hidden' name='bonusAmt' id='bonusAmt' v-bind:value="total_payment"/>
          <input type="hidden" name="generated_answers" v-model="generated_answers">
        </form>

        <div class="alert alert-danger" role="alert" v-if="show_submission_alert">
          There's an error in submission.
        </div>
      </div>
      <br/>
    </div>
  </div>
</template>


<script>
import Vue from 'vue';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import queryString from "query-string";
import _ from 'lodash';
import 'balloon-css';
import DataHandler from './data_handler.js'
import Overview from "./components/Overview.vue";
import StepByStep from "./components/StepByStep.vue";
import Payment from "./components/Payment.vue";
import Question from './components/Question.vue';
import Creation_examples from "./components/Creation_examples"

document.title = "Creation task"

export default {
  name: 'app',
  components: {
    'Overview': Overview,
    'Creation_examples': Creation_examples,
    'Question': Question,
    'StepByStep': StepByStep,
    'Payment': Payment,
  },

  data: function(){
    return {
        active_tab: "overview",

        creation_seeds: [],
        results: "",
        num_generated: 0,
        pass_num: 0,

        mturk_params: {
          assignmentId: "",
          hitId: "",
          turkSubmitTo: "",
          workerId: "",
          isPreview: true,
        },

        generated_answers: {    // JSON file 로 저장한 답안
          0: "",
          1: "",
          2: "",
          3: "",
          4: "",
          5: "",
          6: "",
          7: "",
          8: "",
          feedback: "",
        },

        show_submission_alert: false,

        number_of_questions: 10,
        number_of_additions: 5,
        stage: 0,

        bonus_per_question: 0.7,
        prev_pass: 0,
        prev_add: 0,
        prev_questions: 0,

        data_url: "https://creation-raw-data-storage.click/data",

        host_name: "",
        feedback: "",
        loading: false,
        submitting: false,
        submitted: false,

        addition: false,
        add_times: 0,
        max_add_times: 8,

        error_occurred: false,
    }
  },

  filters: {          // apply common text formatting. be usable in two places: mustache interpolations and v-bind.
    currency: function(value){
      return value.toFixed(2);      // 소수점 아래 2자리까지만 표시.
    }
  },

  computed: {
    show_tab_overview: function(){
      return this.active_tab === "overview"
    },
    show_tab_step_by_step: function(){
      return this.active_tab === "step-by-step"
    },
    show_tab_pay_plan: function(){
      return this.active_tab === "pay-plan"
    },
    show_tab_real_creation: function(){
      return this.active_tab === "real-creation"
    },

    total_payment: function(){              // qualification task total pay.
      return (this.prev_add + this.add_count) * this.bonus_per_question;
    },

    local_debug_mode: function(){       // flask backend database server ip?
      return this.host_name === "localhost"
      // return true
    },

    all_answered(){
      return _.every(this.creation_seeds, (sample) => {
        let item = Object.values(sample)[0]
        if (item.passed === true) {
          return item.pass_reason !== ''
        }
        else {
          return item.question !== '' && item.correct !== '' && item.incorrect !== '' && item.new_question !== ''
              && item.val1 !== false && item.val2 !== false && item.val3 !== false && item.val4 !== false
        }
      })
    },

    pass_count(){
      let count = 0;
      _.each(this.creation_seeds, (sample) => {
        let item = Object.values(sample)[0]
        if (item.passed === true && item.pass_reason !== '') {
          count += 1;
        }
      })
      return count
    },

    add_count(){
      let count = 0;
      _.each(this.creation_seeds, (sample) => {
        let item = Object.values(sample)[0]
        if (item.passed === false
            && item.question !== '' && item.correct !== '' && item.incorrect !== '' && item.new_question !== ''
            && item.val1 !== false && item.val2 !== false && item.val3 !== false && item.val4 !== false) {
          count += 1;
        }
      })
      return count
    },

    not_yet(){
      return this.prev_questions+this.number_of_questions - (this.prev_add + this.add_count) - (this.prev_pass + this.pass_count)
    },

    not_answered(){
      const verification = [];
      _.each(this.creation_seeds, (sample) => {
        let item = Object.values(sample)[0]
        if (item.passed === true) {
          verification.push(item.pass_reason !== '')
        }
        else {
          verification.push(item.question !== '' && item.correct !== '' && item.incorrect !== '' && item.new_question !== ''
              && item.val1 !== false && item.val2 !== false && item.val3 !== false && item.val4 !== false)
        }
      })

      let not_answered_question = []
      for(let i=0; i<Object(verification).length; i++ ){
        if (verification[i] === false){
          not_answered_question.push(i+1)
        }
      }
      return not_answered_question
    },

    no_more_add: function(){
      return this.max_add_times === this.add_times
    }
  },

   mounted: async function(){
      const parsed_query_string = queryString.parse(window.location.search);
      console.log("parsed_query_string", parsed_query_string);
      this.host_name = window.location.hostname
      if (this.local_debug_mode){
        console.log("This is the local debug mode.")
      }

      let assignmentId = parsed_query_string.assignmentId;
      if(assignmentId === null || assignmentId === undefined){
        assignmentId = "TestAssignmentId";
      }
      if (assignmentId === "ASSIGNMENT_ID_NOT_AVAILABLE"){
        console.log("Preview mode.");
        this.mturk_params.isPreview = true;
      }

      const hitId = parsed_query_string.hitId;
      const turkSubmitTo = parsed_query_string.turkSubmitTo;
      let workerId = parsed_query_string.workerId;
      if(workerId === null || workerId === undefined || workerId === ""){
        workerId = "TestUser";
      }

      this.mturk_params.turkSubmitTo = turkSubmitTo + "/mturk/externalSubmit";
      this.mturk_params.workerId = workerId;
      this.mturk_params.hitId = hitId;
      this.mturk_params.assignmentId = assignmentId;

      this.active_tab = 'tab' in parsed_query_string ? parsed_query_string.tab : "overview";
      if(this.active_tab!=="overview"
          &&this.active_tab!=="step-by-step"
          &&this.active_tab!=="pay-plan"
          &&this.active_tab!=="real-creation"){
        this.active_tab = "overview";
      }
      console.log("mturk_params: ", this.mturk_params)

      if("data_url" in parsed_query_string){
        this.data_url = parsed_query_string.data_url;
      }

      let preliminary_data = await DataHandler.fetchQuestions(this.number_of_questions, this.data_url)
      this.load_seeds_csvs(preliminary_data);   // initialize this.creation_seeds
  },

  methods: {
    load_seeds_csvs: function(pre_data){
      this.creation_seeds = [];
      var data = _.map(pre_data, (example) => {
        example.number_of_questions = this.number_of_questions
        example.incorrect = ''
        example.new_question = ''
        example.val1 = false
        example.val2 = false
        example.val3 = false
        example.val4 = false
        example.passed = false
        example.pass_reason = ''
        return example;
      });
      for(let i=0; i<data.length; i++ ){
        const temp = {};
        temp[i+1] = data[i]
        this.creation_seeds.push(temp)
      }
      console.log("creation_seeds:", this.creation_seeds)
      // console.log(this.creation_seeds[0])
    },

    load_additional: async function(){

      this.loading = true;

      // 이전 데이터 저장
      this.results = this.shape_answer(this.creation_seeds);           // make shaped this.results from this.creation_seeds
      this.generated_answers[this.add_times] = JSON.stringify(this.results)
      let feedback_shaped = {};
      feedback_shaped[this.mturk_params.workerId] = this.feedback;
      if (!this.local_debug_mode){
        await DataHandler.writeToS3(this.results, feedback_shaped)
      }

      this.add_times += 1;

      // 새로운 데이터 로드
      this.prev_pass += this.pass_count
      this.prev_add += this.add_count
      this.prev_questions += this.number_of_questions

      this.number_of_questions = this.number_of_additions;
      let preliminary_data = await DataHandler.fetchQuestions(this.number_of_questions, this.data_url)
      this.load_seeds_csvs(preliminary_data);   // initialize this.creation_seeds

      this.stage = 0;
      this.loading = false;
      document.getElementById("workspace_title").scrollIntoView({ behavior: 'smooth'});

      this.addition = true
    },

    switch_tab: function(tab){
      this.active_tab = tab;
    },

    pre_question: function(){
      document.getElementById("workspace_title").scrollIntoView({ behavior: 'smooth'});
      if (this.stage === 0){
        this.stage = this.number_of_questions-1;
      }
      else{
        this.stage -= 1;
      }
    },

    next_question: function(){
      document.getElementById("workspace_title").scrollIntoView({ behavior: 'smooth'});
      if (this.stage === this.number_of_questions-1){
        this.stage = 0;
      }
      else{
        this.stage += 1;
      }
    },


    shape_answer: function(samples_array){
      var results = {};
      for (let i=0; i<samples_array.length; i++){
        var sample = samples_array[i]
        sample = sample[i+1]            // dictionary
        results[sample['question_id']] = {
          'workerId': this.mturk_params.workerId,
          'AssignmentId': this.mturk_params.assignmentId,
          'question': sample['question'],
          'correct': sample['correct'],
          'incorrect': sample['incorrect'],
          'new_question': sample['new_question'],
          'passed': sample['passed'],
          'pass_reason': sample['pass_reason'],
        }
      }
      return results
    },

    submitToUs: async function(){
      this.loading = true;
      this.submitting = true;

      this.results = this.shape_answer(this.creation_seeds);           // make shaped this.results from this.creation_seeds
      this.generated_answers[this.add_times] = JSON.stringify(this.results)
      this.generated_answers['feedback'] = JSON.stringify(this.feedback)

      let feedback_shaped = {};
      feedback_shaped[this.mturk_params.workerId] = this.feedback;

      console.log(this.mturk_params.assignmentId)
      console.log(this.total_payment)
      console.log(this.generated_answers)

      if (!this.local_debug_mode){
        await DataHandler.writeToS3(this.results, feedback_shaped)
      }
      
      this.loading = false;
      this.submitting = false;
      this.submitted = true;
    },

    submitToTurk: async function(){
      if(this.local_debug_mode){
        console.log("Local testing mode. Not submitting to mturk.");
      }
      else{
        Vue.nextTick(function () {
          document.getElementById('mturk-external-submit-form').submit();
        });
      }
    },
  },

}
</script>

<style>
/*noselect {*/
/*  -webkit-touch-callout: none; !* iOS Safari *!*/
/*  -webkit-user-select: none; !* Safari *!*/
/*  -khtml-user-select: none; !* Konqueror HTML *!*/
/*  -moz-user-select: none; !* Old versions of Firefox *!*/
/*  -ms-user-select: none; !* Internet Explorer/Edge *!*/
/*  user-select: none; !* Non-prefixed version, currently*/
/*                                supported by Chrome, Opera and Firefox *!*/
/*}*/


#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  /*-webkit-font-smoothing: antialiased;*/
  /*-moz-osx-font-smoothing: grayscale;*/
  text-align: center;
  color: #2c3e50;
}

button {
  padding: 15px 25px;
  font-size: 24px;
  text-align: center;
  cursor: pointer;
  outline: none;
  color: #fff;
  border: none;
  border-radius: 15px;
}

button:hover {background-color: rgba(8,9,7,0.15)}

/*button:active {*/
/*  transform: translateY(4px);*/
/*}*/


.nav-item.active{
  /*color: red;*/
  border-top-style: solid !important;
  border-bottom-style: solid !important;
  cursor: pointer;
}

.nav-item{
  background-color: white;
  border-bottom: 2px !important;
  border-bottom-style: solid !important;
  border-top: 2px !important;
  border-top-style: solid !important;
  border-left: 2px !important;
  border-left-style: solid !important;
  border-right: 2px !important;
  border-right-style: solid !important;
  cursor: pointer;
  width: 100px;
  margin-left: 6px;
  margin-right: 6px;
}


button:disabled{
  cursor: not-allowed;
}

table {
    /*font-family: arial, sans-serif;*/
    border-collapse: collapse;
    width: auto;
    margin-bottom: 20px;
    background-color: aliceblue;
}

td {
    border: 1px solid lightsteelblue;
    text-align: left;
    padding: 8px;
}

/*.loader {*/
/*  margin: 0 auto;*/
/*  border: 50px solid #f3f3f3; !* Light grey *!*/
/*  border-top: 50px solid #3498db; !* Blue *!*/
/*  border-radius: 100%;*/
/*  width: 330px;*/
/*  height: 330px;*/
/*  animation: spin 1.5s linear infinite;*/
/*}*/
.loader {
  margin: 0 auto;
  border: 15px solid #f3f3f3; /* Light grey */
  border-top: 15px solid deepskyblue; /* Blue */
  border-radius: 100%;
  width: 70px;
  height: 70px;
  animation: spin 1.0s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}


</style>
